var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fullname != '')?_c('div',{staticClass:"avatar2",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }